import type { IconDefinition } from '../index.tsx';

export const iconChevronDoubleBottom: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconChevronDoubleBottom',
  icon: [
    16,
    16,
    [],
    '',
    'M13.8092 6.9804L7.99984 12.7701L2.19046 6.9804L0.585636 8.58532L7.99984 16L15.414 8.58532L13.8092 6.9804ZM13.8092 0.980018L7.99984 6.76974L2.19046 0.980018L0.585636 2.58494L7.99984 9.99962L15.414 2.58494L13.8092 0.980018Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
